import AgilityRichText from "./AgilityRichText";

const TwoColumnsContent = (props) => {
  const { title, content1, content2 } = props;

  return (
    <section className="two-cols-content tw-my-8">
      <div className="tw-container">
        {title && (
          <h2 className="tw-font-roboto tw-text-3.5xl tw-font-bold tw-normal-case tw-mb-5">
            {title}
          </h2>
        )}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8">
          {content1 && <AgilityRichText html={content1} />}
          {content2 && <AgilityRichText html={content2} />}
        </div>
      </div>
    </section>
  );
};

export default TwoColumnsContent;
